import React from 'react'
import Navbar from '../defaultComponents/Navbar'
import Footer from '../defaultComponents/Footer'

import styled from 'styled-components'

import { useNavigate, useParams } from 'react-router-dom'

import dayjs from 'dayjs'

// MUI 
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';

// Contexts
import { CustomerCartProvider, useCart } from './CustomerCartContext.jsx';

const ItemPageWrapper = styled.div`
  background: #f8f8f8;
  font-family: Inter;
`

const ItemBanner = styled.div`
  min-height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`

const ItemBannerTitle = styled.div`
  width: 75vw;
  font-size: 2.5vw;

  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-weight: bold;

  text-transform: uppercase;
`

const ItemBannerTitleBackContainer = styled.div`
  display: flex;
  align-items: center;
`

const ItemBox = styled.div`
  width: 75vw;

  border: 1px solid #E3E4E6;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(67,137,162,0.08);
  background: white;
  min-height: 60vh;

  padding: 1vw;
`

const ItemTitle = styled.div`
  font-size: 2vw;
  font-family: Montserrat;
  font-weight: bold;
  width: 100%;

  display: flex;

  justify-content: space-between;
  align-items: center;

  text-transform: uppercase;
`

const ItemDescBox = styled.div`
  width: 100%;

  display: flex;

  flex-direction: row;
`

const ItemDescBoxLeft = styled.div`
  flex: 0 0 60%;

  border: 1px solid #E3E4E6;
`

const ItemImage = styled.div`
  background: papayawhip;

  height: 80%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  text-transform: uppercase;
`

const ItemDescBoxRight = styled.div`
  flex: 0 0 39%;
  margin-left: 1%;

  border: 1px solid #E3E4E6;

  padding: 2%;
`

const RateCalculator = styled.div`
  height: 100%;
`

const RateTitle = styled.div`
  font-size: 1.5rem;
  height: 10%;
  border-bottom: 1px solid #E3E4E6;
  font-weight: bold;
`

const RateDisplay = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1%;

  border-bottom: 1px solid #E3E4E6;

  font-size: 1.2.rem;
  font-weight: bold;
`

const RateDisplayItem = styled.div`
  padding: 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const RateDisplayValue = styled.div`
  
`

const RateDisplayPeriod = styled.div`
  font-weight: normal;
`

const RatePeriodBox = styled.div`
  display: flex;
  
  gap: 1vw;
  padding-top: 5%;

  &.endDate {
    border-bottom: 1px solid #E3E4E6;
    padding-bottom: 5%;
  }

`

const RateTotal = styled.div`
  display: flex;
  flex-direction: column;

  padding: 1vw;

  &.final{
    margin-top: 5%;
    border: 1px solid papayawhip;
    background: white;
  }
`

const RateTotalTitle = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
`

const RateTotalBreakdown = styled.div`
  display: flex;
  justify-content: space-between;

  align-items: center;

  &.final{
    margin-top: 5%;
    border-top: 1px solid #E3E4E6;
    background: white;
    padding-top: 3%;
  }
`

const RateTotalSubtitle = styled.div`
  font-size: 1rem;
`

const RateTotalValue = styled.div`
  font-weight: bold;
  font-size: 1.2rem;
`

const AddToCartBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vh;

  flex-direction: column;

  font-weight: bold;
`

const AddToCartButton = styled.button`
  background: tomato;
  border: 0;
  width: 100%;

  border-radius: 5px;
  padding: 10px;

  color: white;
  font-size: 1.2rem;

  &:hover {
    background: #e45b4a;
  }
`

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6347',
    },
  },
});

const testData = [
  {
    "asset_id": "1",
    "asset_name": "Traffic Cone",
    "asset_total_stock": "100",
    "in_stock_quantity": "100"
  },
  {
    "asset_id": "2",
    "asset_name": "Speed Bump",
    "asset_total_stock": "50",
    "in_stock_quantity": "50"
  },
  {
    "asset_id": "3",
    "asset_name": "Barricade",
    "asset_total_stock": "30",
    "in_stock_quantity": "30"
  },
  {
    "asset_id": "4",
    "asset_name": "Road Sign",
    "asset_total_stock": "75",
    "in_stock_quantity": "75"
  },
  {
    "asset_id": "5",
    "asset_name": "Flashing Light",
    "asset_total_stock": "40",
    "in_stock_quantity": "40"
  },
  {
    "asset_id": "6",
    "asset_name": "Parking Block",
    "asset_total_stock": "20",
    "in_stock_quantity": "20"
  },
  {
    "asset_id": "7",
    "asset_name": "Traffic Mirror",
    "asset_total_stock": "10",
    "in_stock_quantity": "10"
  },
  {
    "asset_id": "8",
    "asset_name": "Pavement Marker",
    "asset_total_stock": "200",
    "in_stock_quantity": "200"
  },
  {
    "asset_id": "9",
    "asset_name": "Traffic Barrier",
    "asset_total_stock": "15",
    "in_stock_quantity": "15"
  },
  {
    "asset_id": "10",
    "asset_name": "Pedestrian Crossing Signal",
    "asset_total_stock": "8",
    "in_stock_quantity": "8"
  },
  {
    "asset_id": "11",
    "asset_name": "Radar Speed Sign",
    "asset_total_stock": "25",
    "in_stock_quantity": "25"
  },
  {
    "asset_id": "12",
    "asset_name": "Traffic Drum",
    "asset_total_stock": "35",
    "in_stock_quantity": "35"
  },
  {
    "asset_id": "13",
    "asset_name": "Guardrail",
    "asset_total_stock": "45",
    "in_stock_quantity": "45"
  },
  {
    "asset_id": "14",
    "asset_name": "Traffic Delineator",
    "asset_total_stock": "65",
    "in_stock_quantity": "65"
  },
  {
    "asset_id": "15",
    "asset_name": "Lane Divider",
    "asset_total_stock": "55",
    "in_stock_quantity": "55"
  },
  {
    "asset_id": "16",
    "asset_name": "Roundabout Sign",
    "asset_total_stock": "12",
    "in_stock_quantity": "12"
  },
  {
    "asset_id": "17",
    "asset_name": "Speed Limit Sign",
    "asset_total_stock": "150",
    "in_stock_quantity": "150"
  },
  {
    "asset_id": "18",
    "asset_name": "Traffic Camera",
    "asset_total_stock": "5",
    "in_stock_quantity": "5"
  },
  {
    "asset_id": "19",
    "asset_name": "Stop Sign",
    "asset_total_stock": "100",
    "in_stock_quantity": "100"
  },
  {
    "asset_id": "20",
    "asset_name": "Yield Sign",
    "asset_total_stock": "90",
    "in_stock_quantity": "90"
  }
]

export default function AssetItem () {

  const { cart, addToCart } = useCart();

  const navigate = useNavigate()

  const { assetId } = useParams();

  const [startDate, setStartDate] = React.useState(null)
  const [startTime, setStartTime] = React.useState(null)
  const [endDate, setEndDate] = React.useState(null)
  const [endTime, setEndTime] = React.useState(null)

  const [total, setTotal] = React.useState(null)

  const calculateRateTotal = () => {
    // Parse the dates and times
    const startDateTime = dayjs(`${startDate} ${startTime}`, 'DD/MM/YYYY h:mm A');
    const endDateTime = dayjs(`${endDate} ${endTime}`, 'DD/MM/YYYY h:mm A');

    // Check for validity
    if (!startDateTime.isValid()) {
      console.error("Invalid start date/time. Please check your inputs.");
    }
    if (!endDateTime.isValid()) {
      console.error("Invalid end date/time. Please check your inputs.");
    }

    // // // Log the parsed date/time objects for verification
    // console.log("Parsed Start time: ", startDateTime.format());
    // console.log("Parsed End time: ", endDateTime.format());
    console.log(startDate, startTime, endDate, endTime);
    // Calculate the difference
    const hoursDiff = endDateTime.diff(startDateTime, 'hour');
    // console.log(`Total hours: ${hoursDiff}`);

    let totalWeeks = Math.floor((hoursDiff / 24) / 7)

    let hoursMinusWeeks = hoursDiff - (totalWeeks * 7 * 24)

    let totalDays = Math.floor(hoursMinusWeeks / 24)

    let remainingHours = hoursMinusWeeks - (totalDays * 24)

    if (remainingHours > 6){
      remainingHours = 6
    }

    const summaryTotal = totalWeeks * 2000 + totalDays * 300 + remainingHours * 50

    console.log(summaryTotal)

    if (isNaN((summaryTotal)) || summaryTotal < 0) {
      setTotal("Invalid Date/Time");
    }
    else {
      setTotal(summaryTotal);
    }
  };

  React.useEffect(() => {
    if (startDate !== null && endDate !== null && startTime !== null && endTime !== null) {
      calculateRateTotal()
    }
  }, [startDate, endDate, startTime, endTime])


  const [addToCartError, setAddToCartError] = React.useState("")
  const handleAddToCart = () => {

    console.log("CART:", cart)
    if (startTime !== null && endTime !== null && startDate !== null && endDate !== null && total !== "Invalid Date/Time") {
      const newItem ={
        name: `${testData[assetId - 1].asset_name}`,
        quantity: `1`,
        startDate: `${startDate}`,
        startTime: `${startTime}`,
        endDate: `${endDate}`,
        endTime: `${endTime}`,
        rateTotal: `${total}`,
      }
      addToCart(newItem)
      
      setAddToCartError("Added to cart!")
    } else {
      setAddToCartError("Please select date and time")
    }
  }

  return (<>
    <Navbar />
    <ItemPageWrapper>
      <ItemBanner>
        <ItemBannerTitle>
          <ItemBannerTitleBackContainer>
            <IconButton onClick={()=>{navigate("/AssetHire/Inventory")}}>
              <ArrowBackIcon sx={{fontSize:"2vw", color:"tomato", cursor:"pointer"}}/>
            </IconButton>
          {testData[assetId - 1].asset_name}
          </ItemBannerTitleBackContainer>
          <IconButton onClick={()=>{navigate("/AssetHire/Client/Cart")}}>
          <ShoppingCartIcon sx={{fontSize:"2vw", color:"tomato", cursor:"pointer"}} />
          </IconButton>
        </ItemBannerTitle>
        <ItemBox>
          {/* <ItemTitle>{testData[assetId - 1].asset_name}</ItemTitle> */}
          <ItemDescBox>
            <ItemDescBoxLeft>
              <ItemImage>{testData[assetId - 1].asset_name} IMAGE</ItemImage>
            </ItemDescBoxLeft>
            <ItemDescBoxRight>
              <RateCalculator>
                <RateTitle>Hire Rate</RateTitle>
                <RateDisplay>
                  <RateDisplayItem>
                    <RateDisplayValue>$50</RateDisplayValue>
                    <RateDisplayPeriod>1 hour</RateDisplayPeriod>
                  </RateDisplayItem>
                  <RateDisplayItem>
                    <RateDisplayValue>$300</RateDisplayValue>
                    <RateDisplayPeriod>1 day</RateDisplayPeriod>
                    <RateDisplayPeriod>(24 hours)</RateDisplayPeriod>
                  </RateDisplayItem>
                  <RateDisplayItem>
                    <RateDisplayValue>$2000</RateDisplayValue>
                    <RateDisplayPeriod>1 week</RateDisplayPeriod>
                    <RateDisplayPeriod>(7 days)</RateDisplayPeriod>
                  </RateDisplayItem>
                </RateDisplay>
                <ThemeProvider theme={theme}>
                  <RatePeriodBox>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Start Date"
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          const formattedDate = newValue.format('DD/MM/YYYY');
                          setStartDate(formattedDate);
                          console.log(newValue);
                          console.log(formattedDate);
                        }}
                      />
                      <TimePicker label="Start Time" onChange={(newValue) => {
                        const timeString = newValue.format('h:mm A');
                        setStartTime(timeString);
                        console.log(newValue);
                        console.log(timeString);
                      }}
                      />
                    </LocalizationProvider>
                  </RatePeriodBox>
                  <RatePeriodBox className={'endDate'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                      <DatePicker
                        label="End Date"
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          const formattedDate = newValue.format('DD/MM/YYYY');
                          setEndDate(formattedDate);
                          console.log(newValue);
                          console.log(formattedDate);
                        }}
                      />
                      <TimePicker label="End Time" onChange={(newValue) => {
                        const timeString = newValue.format('h:mm A');
                        setEndTime(timeString);
                        console.log(newValue);
                        console.log(timeString);
                      }}
                      />
                    </LocalizationProvider>
                  </RatePeriodBox>
                </ThemeProvider>
                <RateTotal>
                  <RateTotalTitle>Summary</RateTotalTitle>
                  <RateTotalBreakdown>
                    <RateTotalSubtitle>Equipment</RateTotalSubtitle>
                    <RateTotalValue>${total}</RateTotalValue>
                  </RateTotalBreakdown>

                  <RateTotalBreakdown className={"final"}>
                    <RateTotalTitle>Total</RateTotalTitle>
                    <RateTotalValue>${total}</RateTotalValue>
                  </RateTotalBreakdown>
                </RateTotal>

                <AddToCartBox>
                  {addToCartError}
                  <AddToCartButton onClick={()=>{handleAddToCart()}}>
                    <AddShoppingCartIcon /> Add to cart
                  </AddToCartButton>
                </AddToCartBox>

              </RateCalculator>

            </ItemDescBoxRight>
          </ItemDescBox>
        </ItemBox>
      </ItemBanner>
      <Footer />
    </ItemPageWrapper>
  </>)
}
